module.exports = __webpack_public_path__ + "media/images/emoticons/hospital-b1e4fbfe5e1cd97a0fb30a1b72830a38.gif";